import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'
import { SuccessMessage } from 'helpers/messages'

/**
 * Service to get chat-language room
 */
export const getChatLanguageRoomService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/user-chat/get-language-room', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

/**
 * Service to update chat-language-room status
 */
export const updateChatLanguageRoomStatusService = (data) => {
  return axiosInstance(METHOD_TYPES.put, '/user-chat/update-language-room', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    successMessage: SuccessMessage.languageStatusUpdatedSuccessfully
  })
}

/**
 * Service to create chat-language-room
 * @param {object} data - object contains all required properties to create new chat-language-room
 */
export const createChatLanguageRoomService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/user-chat/create-language-room', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.chatLanguageCreatedSuccessfully
  })
}
